import {useSelector, shallowEqual} from 'react-redux';
import HeaderWithAuth from '@jobseeker/feature-navigation/widgets/HeaderAuth';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

import type {AppState} from '@jobseeker/common-core/types';

type HeaderAuthHarnessProps = {
  showHiristPromotionBanner: boolean;
  config?: {
    showNavMenu?: boolean;
    showCourses?: boolean;
    showLogo?: boolean;
    showLoginMenu?: boolean;
  };
};

const HeaderAuthHarness = ({
  showHiristPromotionBanner,
  config: configOverride,
}: HeaderAuthHarnessProps) => {
  const interceptor: any = useInterceptor();
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const isUserLogin: boolean = useSelector(
    (state: AppState) => state.auth.isLoggedIn,
    shallowEqual
  );

  const {
    siteName,
    header: {config, meta},
    proMembership,
  } = interceptor;

  const mergedConfig = configOverride ? {...config, ...configOverride} : config;

  return (
    <HeaderWithAuth
      siteName={siteName}
      config={mergedConfig}
      meta={meta}
      isLoggedIn={isUserLogin}
      page={page}
      subscriptionMeta={proMembership}
      showHiristPromotionBanner={showHiristPromotionBanner}
    />
  );
};

export default HeaderAuthHarness;
